<template>
  <q-list>
    <q-item>
      <q-item-section>
        <q-item-label class="text-bold q-mb-sm">
          Appointment Colour
        </q-item-label>
        <color-field
          v-model="event.color"
          :autofocus="hasNoData"
          :error-message="!!errors['color'] ? errors['color'][0] : null"
        />
      </q-item-section>
    </q-item>

    <!-- List staff icons -->
    <div v-if="event.attendees.length > 0" class="q-mt-lg">
      <q-item-label header class="q-pb-none">
        Staff Members
      </q-item-label>
      <q-item-label caption class="q-px-md q-pb-sm">
        Click on a staff icon to use their colour on this appointment
      </q-item-label>
      <div class="q-px-md flex q-gutter-sm">
        <profile-image
          v-for="(user, key) in event.attendees"
          :key="key"
          :color="user.color"
          :master="user.created_company"
          :initials="user.initials"
          :tooltip="user.name"
          :disable="user.color === event.color"
          clickable
          @click="event.color = user.color"
        />
      </div>
    </div>

    <!-- List appointment types -->
    <div v-if="event.types.length > 0" class="q-mt-lg">
      <q-item-label header class="q-pb-none">
        Appointment Types
      </q-item-label>
      <q-item-label caption class="q-px-md q-pb-sm">
        Click on an appointment type to use its colour on this appointment
      </q-item-label>
      <div class="q-px-md flex q-gutter-sm">
        <q-chip
          v-for="(opt, key) in event.types"
          :key="key"
          :disable="opt.color === event.color"
          color="blue-grey-1"
          class="shadow-1"
          clickable
          @click="event.color = opt.color"
        >
          <span
            class="dot"
            :style="{'background-color': opt.color}"
          />
          <span class="q-ml-sm">
            {{ truncateString(opt.shorthand_name || opt.name) }}
          </span>
        </q-chip>
      </div>
    </div>
  </q-list>
</template>

<script>
export default {
  props: {
    event: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    hasNoData () {
      return this.event.attendees.length < 1 && this.event.types.length < 1
    }
  }
}
</script>
